/* Zefria — animazioni di comparsa + galleria prodotto. Tutto ha un fallback: il contenuto non resta mai nascosto. */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.zf-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // fallback: se l'observer non scatta (editor, iframe, tab in background) mostra tutto
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  }

  function gallery(root) {
    (root || document).querySelectorAll('[data-zf-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var main = g.querySelector('.js-zf-main');
      g.querySelectorAll('[data-zf-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('[data-zf-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
          main.style.opacity = 0;
          setTimeout(function () { main.src = btn.dataset.src; main.srcset = btn.dataset.srcset || ''; main.style.opacity = 1; }, 150);
        });
      });
    });
  }

  function newsletter(root) {
    (root || document).querySelectorAll('[data-zf-news]').forEach(function (f) {
      if (location.search.indexOf('customer_posted=true') > -1 || location.hash === '#zf-news-ok') {
        var m = f.parentNode.querySelector('.zf-foot__msg'); if (m) m.hidden = false;
      }
    });
  }

  function toTop(root) {
    (root || document).querySelectorAll("[data-zf-top]").forEach(function (a) {
      if (a.dataset.ready) return; a.dataset.ready = "1";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var t = document.querySelector("product-form-component, .product-details, .product-information") || document.body;
        var y = t.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      });
    });
  }

  // Il popup EcomSend mostra il nome di un altro negozio nel consenso SMS: lo correggo finché non viene cambiato nell app.
  function fixPopupBrand() {
    var fix = function () {
      document.querySelectorAll(".ecomsend__Modal__DescriptionText span, .ecomsend__Modal__DescriptionText p").forEach(function (el) {
        el.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.indexOf("Sofyre") > -1) n.textContent = n.textContent.replace(/Sofyre/g, "Zefria"); });
      });
    };
    if ("MutationObserver" in window) new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
    fix();
  }

  // Bottone "Add to cart" della PDP: pillola con prezzo pieno barrato + prezzo del pacchetto Kaching selezionato, e freccia.
  function atcPrice() {
    var btn = document.querySelector("add-to-cart-component .add-to-cart-button");
    if (!btn || btn.dataset.zfAtc) return;
    btn.dataset.zfAtc = "1";
    btn.classList.add("zf-atc");
    var pill = document.createElement("span");
    pill.className = "zf-atc__pill"; pill.hidden = true;
    pill.innerHTML = "<s class=\"zf-atc__was\"></s><span class=\"zf-atc__now\"></span>";
    var arrow = document.createElement("span");
    arrow.className = "zf-atc__arrow"; arrow.setAttribute("aria-hidden", "true"); arrow.textContent = "\u2192";
    var added = btn.querySelector(".add-to-cart__added");
    btn.insertBefore(pill, added); btn.insertBefore(arrow, added);
    var update = function () {
      var bar = document.querySelector(".kaching-bundles__bar--selected");
      var now = bar && bar.querySelector(".kaching-bundles__bar-price");
      var was = bar && bar.querySelector(".kaching-bundles__bar-full-price");
      var n = now ? now.textContent.trim() : "", w = was ? was.textContent.trim() : "";
      if (!n) { pill.hidden = true; return; }
      pill.hidden = false;
      pill.querySelector(".zf-atc__now").textContent = n;
      var ws = pill.querySelector(".zf-atc__was");
      ws.textContent = (w && w !== n) ? w : ""; ws.hidden = !(w && w !== n);
    };
    update();
    var box = document.querySelector(".kaching-bundles") || document.body;
    if ("MutationObserver" in window) new MutationObserver(update).observe(box, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["class"] });
    document.addEventListener("change", update);
  }
  function atcWhenReady() {
    var tries = 0;
    var t = setInterval(function () { atcPrice(); if (document.querySelector(".zf-atc") && document.querySelector(".kaching-bundles__bar--selected") || ++tries > 40) { clearInterval(t); atcPrice(); } }, 250);
  }

  function init(root) { reveal(root); gallery(root); newsletter(root); toTop(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); fixPopupBrand(); atcWhenReady(); }); else { init(); fixPopupBrand(); atcWhenReady(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
